import Vue from "vue";
const state = {
    tableList: [], //物流跟踪订阅页面表格数据列设置
    tableListSH: [],
    tableListQD: [],
    tableListTJ: [],
    tableListXM: [],
    tableListSZ: [],
    tableListDL: [],
    shiptableList: [], //船期订阅页列设置
    shiptableListSH: [],
    shiptableListQD: [],
    shiptableListTJ: [],
    shiptableListXM: [],
    shiptableListSZ: [],
    shiptableListDL: [],
    tagNavList: [],
    queryList: [], // 物流实时查询箱货跟踪列设置
    queryList2: [], // 物流实时查询船期列设置
    queryList3: [], // 物流实时查询预配舱单列设置
    historyList: [], // 历史记录列设置
    historyListSH: [], // 历史记录列设置
    historyListQD: [], // 历史记录列设置
    manifestList: [], //宁波舱单页
    userColumnList: [], //用户自定义列设置
    tableListDesignated: [], // 指定箱列设置
    tableListAssistant: [], // 义乌数据同步列设置
    sortMethods: "", //仓单页面排序状态
    manifestSHTableListDraft: [], // 上海舱单草稿箱页面列设置
    manifestSHTableListWaitSend: [], // 上海舱单待发送页面列设置
    manifestSHTableListAlreadySend: [], // 上海舱单已发送页面列设置
    manifestSHTableListEditDelete: [], // 上海舱单已删改页面列设置
    manifestSHTableListDeskDelete: [], // 上海舱单柜台删单页面列设置
    manifestSHTableListDustbin: [], // 上海舱单垃圾箱页面列设置
    vgmTableListDraft: [], // VGM草稿箱页面列设置
    vgmTableListWaitSend: [], // VGM待发送页面列设置
    vgmTableListAlreadySend: [], // VGM已发送页面列设置
    manifestQDTableListDraft: [], // 青岛舱单草稿箱页面列设置
    manifestQDTableListWaitSend: [], // 青岛舱单待发送页面列设置
    manifestQDTableListAlreadySend: [], // 青岛舱单已发送页面列设置
    manifestQDTableListEditDelete: [], // 青岛舱单已删改页面列设置
    manifestQDTableListDeskDelete: [], // 青岛舱单柜台删单页面列设置
    manifestQDTableListDustbin: [], // 青岛舱单垃圾箱页面列设置
    assistantGoodsColumnOrder: [], // 助手商品表格列顺序
    assistantGoodsColumnHash: "", // 助手商品表格列配置哈希值，用于检测列定义变化
    pageSize: 15,
    pageSize2: 15,
    liststate: 0,
    showTabber: true,
    showTabbers: false,
};

const getColumnList = (payload = []) => {
    // 如果是对象的话直接返回
    if (Object.prototype.toString.call(payload) === "[object Object]") {
        return [payload];
    }
    let list = [];
    payload.forEach((element) => {
        let data = {
            ...element,
            fixed: Boolean(element.fixed) || false,
        };
        list.push(data);
    });
    return list;
};

const mutations = {
    editTableListNB(state, payload) {
        state.tableList = payload;
    },
    editTableListSH(state, payload) {
        state.tableListSH = payload;
    },
    editTableListQD(state, payload) {
        state.tableListQD = payload;
    },
    editTableListTJ(state, payload) {
        state.tableListTJ = payload;
    },
    editTableListXM(state, payload) {
        state.tableListXM = payload;
    },
    editTableListSZ(state, payload) {
        state.tableListSZ = payload;
    },
    editTableListDL(state, payload) {
        state.tableListDL = payload;
    },
    editShipTableListNB(state, payload) {
        state.shiptableList = payload;
    },
    editShipTableListSH(state, payload) {
        state.shiptableListSH = payload;
    },
    editShipTableListQD(state, payload) {
        state.shiptableListQD = payload;
    },
    editShipTableListTJ(state, payload) {
        state.shiptableListTJ = payload;
    },
    editShipTableListXM(state, payload) {
        state.shiptableListXM = payload;
    },
    editShipTableListSZ(state, payload) {
        state.shiptableListSZ = payload;
    },
    editShipTableListDL(state, payload) {
        state.shiptableListDL = payload;
    },
    editShowTabber(state, payload) {
        state.showTabber = payload;
    },
    editShowTabbers(state, payload) {
        state.showTabbers = payload;
    },
    editListState(state, payload) {
        state.liststate = payload;
    },
    editPageSize(state, payload) {
        Vue.set(state, "pageSize", payload);
    },
    editPageSize2(state, payload) {
        state.pageSize2 = payload;
    },
    editsortMethods(state, payload) {
        state.sortMethods = payload;
    },
    editManifestList(state, payload) {
        state.manifestList = payload;
    },
    editHistoryList(state, payload) {
        state.historyList = getColumnList(payload);
    },
    editHistoryListSH(state, payload) {
        state.historyListSH = getColumnList(payload);
    },
    editHistoryListQD(state, payload) {
        state.historyListQD = getColumnList(payload);
    },
    editTableListDesignated(state, payload) {
        state.tableListDesignated = payload;
    },
    editTableListAssistant(state, payload) {
        state.tableListAssistant = payload;
    },
    resetManifestListTableList(state, payload) {
        state.manifestList = getColumnList(payload);
    },
    resetTableListNB(state, payload) {
        state.tableList = getColumnList(payload);
    },
    resetTableListSH(state, payload) {
        state.tableListSH = getColumnList(payload);
    },
    resetTableListQD(state, payload) {
        state.tableListQD = getColumnList(payload);
    },
    resetTableListTJ(state, payload) {
        state.tableListTJ = getColumnList(payload);
    },
    resetTableListXM(state, payload) {
        state.tableListXM = getColumnList(payload);
    },
    resetTableListSZ(state, payload) {
        state.tableListSZ = getColumnList(payload);
    },
    resetTableListDL(state, payload) {
        state.tableListDL = getColumnList(payload);
    },
    resetShipTableListNB(state, payload) {
        state.shiptableList = getColumnList(payload);
    },
    resetShipTableListSH(state, payload) {
        state.shiptableListSH = getColumnList(payload);
    },
    resetShipTableListQD(state, payload) {
        state.shiptableListQD = getColumnList(payload);
    },
    resetShipTableListTJ(state, payload) {
        state.shiptableListTJ = getColumnList(payload);
    },
    resetShipTableListXM(state, payload) {
        state.shiptableListXM = getColumnList(payload);
    },
    resetShipTableListSZ(state, payload) {
        state.shiptableListSZ = getColumnList(payload);
    },
    resetShipTableListDL(state, payload) {
        state.shiptableListDL = getColumnList(payload);
    },
    resetshowTabber(state, payload) {
        state.showTabber = payload;
    },
    resetshowTabbers(state, payload) {
        state.showTabbers = payload;
    },
    queryTableList(state, payload) {
        state.queryList = getColumnList(payload);
    },
    queryTableList2(state, payload) {
        state.queryList2 = getColumnList(payload);
    },
    queryTableList3(state, payload) {
        state.queryList3 = getColumnList(payload);
    },
    resetHistoryList(state, payload) {
        state.historyList = getColumnList(payload);
    },
    resetHistoryListSH(state, payload) {
        state.historyListSH = getColumnList(payload);
    },
    resetHistoryListQD(state, payload) {
        state.historyListQD = getColumnList(payload);
    },
    // 上海舱单相关页面列设置
    resetManifestSHTableListDraft(state, payload) {
        state.manifestSHTableListDraft = getColumnList(payload);
    },
    resetManifestSHTableListWaitSend(state, payload) {
        state.manifestSHTableListWaitSend = getColumnList(payload);
    },
    resetManifestSHTableListAlreadySend(state, payload) {
        state.manifestSHTableListAlreadySend = getColumnList(payload);
    },
    resetManifestSHTableListEditDelete(state, payload) {
        state.manifestSHTableListEditDelete = getColumnList(payload);
    },
    resetManifestSHTableListDeskDelete(state, payload) {
        state.manifestSHTableListDeskDelete = getColumnList(payload);
    },
    resetManifestSHTableListDustbin(state, payload) {
        state.manifestSHTableListDustbin = getColumnList(payload);
    },
    editManifestSHTableListDraft(state, payload) {
        state.manifestSHTableListDraft = getColumnList(payload);
    },
    editManifestSHTableListWaitSend(state, payload) {
        state.manifestSHTableListWaitSend = getColumnList(payload);
    },
    editManifestSHTableListAlreadySend(state, payload) {
        state.manifestSHTableListAlreadySend = getColumnList(payload);
    },
    editManifestSHTableListEditDelete(state, payload) {
        state.manifestSHTableListEditDelete = getColumnList(payload);
    },
    editManifestSHTableListDeskDelete(state, payload) {
        state.manifestSHTableListDeskDelete = getColumnList(payload);
    },
    editManifestSHTableListDustbin(state, payload) {
        state.manifestSHTableListDustbin = getColumnList(payload);
    },
    // 青岛舱单相关页面列设置
    resetManifestQDTableListDraft(state, payload) {
        state.manifestQDTableListDraft = getColumnList(payload);
    },
    resetManifestQDTableListWaitSend(state, payload) {
        state.manifestQDTableListWaitSend = getColumnList(payload);
    },
    resetManifestQDTableListAlreadySend(state, payload) {
        state.manifestQDTableListAlreadySend = getColumnList(payload);
    },
    resetManifestQDTableListEditDelete(state, payload) {
        state.manifestQDTableListEditDelete = getColumnList(payload);
    },
    resetManifestQDTableListDeskDelete(state, payload) {
        state.manifestQDTableListDeskDelete = getColumnList(payload);
    },
    resetManifestQDTableListDustbin(state, payload) {
        state.manifestQDTableListDustbin = getColumnList(payload);
    },
    editManifestQDTableListDraft(state, payload) {
        state.manifestQDTableListDraft = getColumnList(payload);
    },
    editManifestQDTableListWaitSend(state, payload) {
        state.manifestQDTableListWaitSend = getColumnList(payload);
    },
    editManifestQDTableListAlreadySend(state, payload) {
        state.manifestQDTableListAlreadySend = getColumnList(payload);
    },
    editManifestQDTableListEditDelete(state, payload) {
        state.manifestQDTableListEditDelete = getColumnList(payload);
    },
    editManifestQDTableListDeskDelete(state, payload) {
        state.manifestQDTableListDeskDelete = getColumnList(payload);
    },
    editManifestQDTableListDustbin(state, payload) {
        state.manifestQDTableListDustbin = getColumnList(payload);
    },
    // VGM相关页面列设置
    editVgmTableListDraft(state, payload) {
        state.vgmTableListDraft = getColumnList(payload);
    },
    editVgmTableListWaitSend(state, payload) {
        state.vgmTableListWaitSend = getColumnList(payload);
    },
    editVgmTableListAlreadySend(state, payload) {
        state.vgmTableListAlreadySend = getColumnList(payload);
    },
    resetVgmTableListDraft(state, payload) {
        state.vgmTableListDraft = getColumnList(payload);
    },
    resetVgmTableListWaitSend(state, payload) {
        state.vgmTableListWaitSend = getColumnList(payload);
    },
    resetVgmTableListAlreadySend(state, payload) {
        state.vgmTableListAlreadySend = getColumnList(payload);
    },
    // 助手商品表格列顺序
    setAssistantGoodsColumnOrder(state, payload) {
        state.assistantGoodsColumnOrder = payload.columns || [];
        state.assistantGoodsColumnHash = payload.hash || "";
    },
    resetAssistantGoodsColumnOrder(state) {
        state.assistantGoodsColumnOrder = [];
        state.assistantGoodsColumnHash = "";
    },
};

const actions = {
    editTableList({ commit }, state) {
        commit("editTableList", state);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
